import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'

interface Props {
  unavailable_fields: string[] | null
}

const MissingSalaryCode = ({ unavailable_fields }: Props) => {
  return (unavailable_fields ?? [])
    .filter((field) => ['missing_salary_code', 'missing_legal_entity_mapping'].includes(field))
    .map((field: string) => (
      <Box
        background="radicalRed200"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{
          all: 'abs008',
        }}
        gap="s16"
        key={field}
      >
        <Text.Header2 key={field}>{fieldTranslations.t(field)}</Text.Header2>

        <Box>
          {i18n.t(
            'payroll_integrations.incidences.datev_lauds.hiring.missing_salary_code.description'
          )}
        </Box>
      </Box>
    ))
}

export default MissingSalaryCode
